import React, { memo, useState, useCallback, FC } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import {CollapsibleBodyProps, TabItem} from "./types";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select, {SelectChangeEvent} from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// Заглушки для будущих страниц
const StubConnectionSettings: FC = () => (<Typography>Connection Settings placeholder</Typography>);
const StubMMSettings: FC = () => (<Typography>MM Settings placeholder</Typography>);
const StubSpread: FC = () => <Typography>Spread placeholder</Typography>;
const StubVolumes: FC = () => <Typography>Volumes placeholder</Typography>;
const StubDynamicBook: FC = () => <Typography>Dynamic Book placeholder</Typography>;
const StubLiquidSettings: FC = () => (<Typography>Liquid Settings placeholder</Typography>);
const StubSwapBalances: FC = () => (<Typography>Swap Balances placeholder</Typography>);

// Конфиг вкладок с заглушками
const TABS: TabItem[] = [
    { label: "Connection Settings", Component: StubConnectionSettings },
    { label: "MM Settings",         Component: StubMMSettings },
    { label: "Spread Skip",              Component: StubSpread },
    { label: "Volume Increase",             Component: StubVolumes },
    { label: "Dynamic Book",        Component: StubDynamicBook },
    { label: "Liquid Settings",     Component: StubLiquidSettings },
    { label: "Swap Balances",       Component: StubSwapBalances },
];

export const CollapsibleBody = memo(function CollapsibleBody({
    compactMode = false,
}: CollapsibleBodyProps) {
    const [activeTab, setActiveTab] = useState(0);

    // для desktop tabs
    const handleChangeTab = useCallback(
        (_: React.SyntheticEvent, newValue: number) => {
            setActiveTab(newValue);
        },
        []
    );
    // для mobile select
    const handleSelectTab = useCallback(
        (event: SelectChangeEvent<number>, _: React.ReactNode) => {
            setActiveTab(event.target.value as number);
        },
        []
    );

    // Вытаскиваем компонент активной вкладки
    const ActiveComponent = TABS[activeTab].Component;

    // desktop / tablet
    if (!compactMode) {
        return (
            <Box
                sx={{
                    display: "flex",
                    bgcolor: "background.paper",
                    width: "100%",
                }}
            >
                <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={activeTab}
                    onChange={handleChangeTab}
                    aria-label="Connection pair settings tabs"
                    sx={{
                        borderRight: 1,
                        borderColor: "divider",
                        minWidth: 160,
                    }}
                >
                    {TABS.map((tab, idx) => (
                        <Tab
                            key={idx}
                            label={tab.label}
                            id={`vertical-tab-${idx}`}
                            aria-controls={`vertical-tabpanel-${idx}`}
                        />
                    ))}
                </Tabs>

                {TABS.map((tab, idx) => (
                    <Box
                        key={idx}
                        role="tabpanel"
                        hidden={activeTab !== idx}
                        id={`vertical-tabpanel-${idx}`}
                        aria-labelledby={`vertical-tab-${idx}`}
                        sx={{ p: 2, flex: 1 }}
                    >
                        {activeTab === idx && <tab.Component />}
                    </Box>
                ))}
            </Box>
        );
    }

    // mobile
    return (
        <Box
            sx={{
                pt: 2,
                display: "flex",
                flexDirection: "column",
                bgcolor: "background.paper",
                width: "100%",
            }}
        >
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                <InputLabel id="mobile-tab-select-label">Section</InputLabel>
                <Select
                    labelId="mobile-tab-select-label"
                    value={activeTab}
                    label="Section"
                    onChange={handleSelectTab}
                >
                    {TABS.map((tab, idx) => (
                        <MenuItem key={idx} value={idx}>
                            {tab.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <Box sx={{ p: 2 }}>
                <ActiveComponent />
            </Box>
        </Box>
    );
});